import { Button, Input, Radio, Select, Upload } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import { Controller } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';
import Icon from '../Icon/Icon';
import Popup from '../Popup/Popup';
import { Props } from './HelpRequest.model';

import styles from './HelpRequest.module.scss';
import { useHelpRequest } from './useHelpRequest';
import {WORDPRESS_DOMAIN} from "../../Helpers/EnvVars";

const HelpRequest = ({ onClose }: Props) => {
	const { control, errors, getIconByFileType, handleSubmit, onChangeFiles, onPopupClose, state, submitFeedback } = useHelpRequest({ onClose });
	const { email, files, isSubmitted, topics } = state;
	const intl = useIntl();

	return <Popup
		height="full-height"
		onClose={onClose}
		title={{ action: '', target: 'help' }}
		size="extra-small"
		actions={<div className={styles.buttonsWrapper}>
			<Button type="default" size="large" onClick={onPopupClose.bind(null, onClose)}><FormattedMessage id="buttons.cancel" /></Button>
			<Button type="primary" size="large" onClick={handleSubmit(submitFeedback)}><FormattedMessage id="buttons.submit" /></Button>
		</div>}
	>
		{!isSubmitted ? <div className={styles.content}>
			<div className={styles.faq}>
				<div className={styles.titleWithIcon} ><Icon name="comment-alt-lines" width="16px" color="light" type="solid"/>
					<h2><FormattedMessage id="formLabels.faq" /></h2>
				</div>
				<a href={`${WORDPRESS_DOMAIN}/faq`} target="_blank" rel="noreferrer" >{WORDPRESS_DOMAIN}/faq</a>
			</div>
			<div className={styles.fieldWrapper}>
				<label className={styles.floatingLabel}>
					<FormattedMessage id={`feedback.labels.topics`} />
				</label>
				<Controller
					name="topics"
					control={control}
					rules={{ required: true }}
					render={({ field }) =>
						<Select
							className={`${styles.w100} ${errors['topics'] && 'error'}`}
							{...field}
							placeholder={intl.formatMessage({ id: "formPlaceholders.selectTopic" })}>
							{topics?.map((topic, index) => <Select.Option value={topic} key={index}><FormattedMessage id={`feedback.topics.${topic}`} /></Select.Option>)}
						</Select>}
				/>
			</div>
			<div className={styles.fieldWrapper}>
				<label className={styles.floatingLabel}>
					<FormattedMessage id={`feedback.labels.title`} />
				</label>
				<Controller
					name="shortDescription"
					control={control}
					rules={{ required: true }}
					render={({ field }) =>
						<Input
							className={errors['shortDescription'] && 'error'}
							{...field}
							placeholder={intl.formatMessage({ id: "formPlaceholders.shortDescription" })} />}
				/>
			</div>
			<div className={`${styles.fieldWrapper} ${styles.uploads}`}>
				<label className={styles.floatingLabel}>
					<FormattedMessage id={`feedback.labels.fileAttachements`} />
				</label>
				<Upload
					accept=".jpg, .jpeg, .png, .mov, .pdf, .docx"
					showUploadList={{ showPreviewIcon: false }}
					fileList={files}
					onChange={onChangeFiles}
					maxCount={5}
					openFileDialogOnClick={files.length < 5}
					itemRender={(node, file, fileList: object[], actions: { remove: () => void }) =>
						<div className={styles.uploadedItem}>
							<Icon color="light" name={getIconByFileType(file?.originFileObj?.type)} type="solid" width="16px" />
							<span>{file.originFileObj?.name}</span>
							<div className={styles.remove} onClick={actions.remove}><Icon color="red" name="times" width="16px" /></div>
						</div>}
				>
					<Input value="" className={styles.uploadInput} placeholder={files.length >= 5 ? intl.formatMessage({ id: "formPlaceholders.maxFiles" }) : intl.formatMessage({ id: "formPlaceholders.upload" })} />
				</Upload>
			</div>
			<div className={styles.fieldWrapper}>
				<label className={styles.floatingLabel}>
					<FormattedMessage id={`feedback.labels.description`} />
				</label>
				<Controller
					name="description"
					control={control}
					rules={{ required: true }}
					render={({ field }) =>
						<TextArea
							className={errors['description'] && 'error'}
							{...field}
							rows={10}
							placeholder={intl.formatMessage({ id: "formPlaceholders.description" })} />}
				/>
			</div>
		</div> :
			<div className={styles.finishReview} >
				<div className={`${styles.content} ${styles.scrollable}`}>
					<span className={styles.closeIcon} onClick={onPopupClose.bind(null, onClose)}>
						<Icon name='times' color='black' />
					</span>
					<Icon className={styles.icon} color="green" name="badge-check" type="light" />
					<h1><FormattedMessage id="feedback.help.thankYou.title" /></h1>
					<div className={styles.info}><FormattedMessage id="feedback.help.thankYou.info" values={{ email }} /></div>
					<Button type="link" onClick={onPopupClose.bind(null, onClose)}><FormattedMessage id="feedback.thankYou.finish" /></Button>
				</div>
			</div>
		}
	</Popup>
}
export default HelpRequest;